import { defineStore } from "pinia";
import { useInventoryStore } from "./inventoryStore.js";

export const useUpgradeStore = defineStore("upgrades", {
  state: () => ({
    purchased: []
  }),
  getters: {
    hasPurchased: (state) => (upgradeId) => state.purchased.includes(upgradeId)
  },
  actions: {
    canAfford(upgrade) {
      const inventory = useInventoryStore();
      for (const [material, amount] of Object.entries(upgrade.cost)) {
        if ((inventory.materials[material] || 0) < amount) return false;
      }
      return true;
    },
    purchase(upgrade) {
      if (this.hasPurchased(upgrade.id)) return false;
      if (!this.canAfford(upgrade)) return false;

      const inventory = useInventoryStore();
      for (const [material, amount] of Object.entries(upgrade.cost)) {
        inventory.materials[material] -= amount;
      }
      this.purchased.push(upgrade.id);
      return true;
    }
  }
});
